"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformData = transformData;
exports.reverseTransformData = reverseTransformData;
function transformData(data, keyMapping, utilFunctions = {}) {
    if (Array.isArray(data)) {
        return data.map((item) => transformData(item, keyMapping, utilFunctions));
    }
    if (typeof data === "object" && data !== null) {
        return Object.entries(data).reduce((acc, [key, value]) => {
            const mapping = keyMapping[key];
            const utilFunction = utilFunctions[key];
            if (!mapping && !utilFunction)
                return acc;
            let transformedValue = value;
            if (utilFunction) {
                transformedValue = utilFunction(transformedValue, data);
            }
            if (mapping) {
                if (typeof mapping === "object") {
                    acc[mapping.key || key] = transformData(transformedValue, mapping, utilFunctions);
                }
                else if (typeof mapping === "string") {
                    acc[mapping] = transformedValue;
                }
            }
            return acc;
        }, {});
    }
    return data;
}
function inverseMapping(mapping) {
    return Object.entries(mapping).reduce((acc, [key, value]) => {
        if (typeof value === "object" && !Array.isArray(value)) {
            acc[key] = inverseMapping(value);
        }
        else if (typeof value === "string") {
            acc[value] = key;
        }
        return acc;
    }, {});
}
function reverseTransformData(data, mapping) {
    const apiMapping = inverseMapping(mapping);
    return transformData(data, apiMapping);
}
